import { render, staticRenderFns } from "./TaxReturnStarterDeductionSection.vue?vue&type=template&id=7884d5fa&scoped=true&"
import script from "./TaxReturnStarterDeductionSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnStarterDeductionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7884d5fa",
  null
  
)

export default component.exports